module.exports = __webpack_public_path__ + "img/individual@2x.4e8f415.jpg";